const downloadAppRedirect = {
    title: 'Переход на скачивание приложения...',
    backBtn: 'Вернуться в каталог',
};

export default downloadAppRedirect;
